module.exports = __webpack_public_path__ + "img/default.e1826648.jpg";